import type { NavigationMenuItem } from '#ui/types';

export type MaybeNavItem = NavigationMenuItem | false | null | undefined;

// Type guard for the `.filter()` at the end of a nav menu: drops feature-flag-
// gated falsy entries and narrows back to NavigationMenuItem[]. Type the source
// array as `MaybeNavItem[]` so typed-route `to` names stay validated per item
// (no widening to `string`, no blanket @ts-expect-error).
export const isNavItem = (item: MaybeNavItem): item is NavigationMenuItem => Boolean(item);
